import { createContext, useContextSelector } from '@fluentui/react-context-selector';
import { defaultTableState } from '../hooks';
const dataGridContext = createContext(undefined);
const dataGridContextDefaultValue = {
    ...defaultTableState,
    subtleSelection: false,
    selectableRows: false,
    selectionAppearance: 'brand',
    focusMode: 'none',
    compositeRowTabsterAttribute: {}
};
export const DataGridContextProvider = dataGridContext.Provider;
export const useDataGridContext_unstable = (selector)=>useContextSelector(dataGridContext, (ctx = dataGridContextDefaultValue)=>selector(ctx));
